import { render, staticRenderFns } from "./FormItemInput.vue?vue&type=template&id=60a45bef&scoped=true&"
import script from "./FormItemInput.vue?vue&type=script&lang=js&"
export * from "./FormItemInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a45bef",
  null
  
)

export default component.exports